<template>
	<div class="vip_detail">
		<!-- 用户卡片信息 -->
		<div class="user_info_card">
			<div class="user_info_left">
				<div class="user_avatar">
					<img :src="user.avatar">
				</div>
				<div class="user_name_time">
					<div class="user_name">{{user.nickname}}</div>
					<div class="user_time" v-if="vipInfo.status === 1">会员有效期至：{{ vipInfo.end_time }}</div>
					<div class="user_time" v-if="vipInfo.status !== 1">您当前未开通一席会员</div>
				</div>
			</div>
			<div class="card_btn">
				<div class="vip_btn" @click="buy_vip()">
					<span v-if="vipInfo.status === 1">立即续费</span>
					<span v-else>立即开通</span>
				</div>
			</div>
		</div>
		<!-- 会员权益 -->
		<div class="vipEquity">
			<div class="vip_title">
				<div class="shu"></div>
				<div class="title_txt">会员权益</div>	
			</div>
			<div class="equity">
				<div class="equity_item" v-for="(item,i) in member_items" :key="i">
					<div class="equity_item_title">{{item.title}}</div>
					<div class="equity_item_intro">{{item.intro}}</div>
				</div>
			</div>
		</div>
		<!-- 年费会员礼物 -->
		<div class="gift_maContent">
			<div class="vip_title">
				<div class="shu"></div>
				<div class="title_txt">年费会员礼物</div>	
			</div>
			<div class="gift_tisp">可在App内查看资格和领取</div>
			<!-- <div class="gift_content">
				<div class="gift_item" v-for="(item,i) in gift_infos" :key="i">
					<div class="gift_item_img"><img :src="item.cover" alt=""></div>
					<div class="gift_item_title">{{item.name}}</div>
					<div class="gift_item_price">¥{{item.price_max}}</div>
				</div>
			</div> -->
			<div class="giftContent-swiper-bl">
			 <swiper class="swiper" :options="giftContentSwiperOption" >
			   <swiper-slide v-for="item in gift_infos" :key="item.id">
				   <div class="giftContent_item">
					   <div class="maContent_item_img">
						   <img :src="item.cover" alt="">
					   </div>
					   <div class="maContent_item_title">{{item.name}}</div>
					   <div class="maContent_item_intro">{{item.price_max}}</div>
					   
				   </div>
			    </swiper-slide>
			  </swiper>
			  <div class="swiper-btn-wrap">
			    <div class="giftContent swiper-btn-prev swiper-btn">
			      <i class="iconfont iconarrow_left"></i>
			    </div>
			    <div class="giftContent swiper-btn-next swiper-btn">
			      <i class="iconfont iconarrow_right"></i>
			    </div>
			  </div>
			</div>
		</div>
		<!-- 尊享会员礼物 -->
		<div class="vipgift_maContent">
			<div class="vip_title">
				<div class="shu"></div>
				<div class="title_txt">尊享会员礼物</div>	
			</div>
			<div class="gift_tisp">可在App内查看资格和领取</div>
			<div class="vipgiftContent-swiper-bl">
			 <swiper class="swiper" :options="vipgiftContentSwiperOption" >
			   <swiper-slide v-for="item in gift_infos_vip" :key="item.id">
				   <div class="vipgiftContent_item">
					   <div class="maContent_item_img">
						   <img :src="item.cover" alt="">
					   </div>
					   <div class="maContent_item_title">{{item.name}}</div>
					   <div class="maContent_item_intro">{{item.price_max}}</div>
					   
				   </div>
			    </swiper-slide>
			  </swiper>
			  <div class="swiper-btn-wrap">
			    <div class="vipgiftContent swiper-btn-prev swiper-btn">
			      <i class="iconfont iconarrow_left"></i>
			    </div>
			    <div class="vipgiftContent swiper-btn-next swiper-btn">
			      <i class="iconfont iconarrow_right"></i>
			    </div>
			  </div>
			</div>
		</div>


		<!-- 会员精彩内容 -->
		<div class="vip_maContent">
			<div class="vip_title">
				<div class="shu"></div>
				<div class="title_txt">会员畅享</div>
			</div>
			<div class="maContent-swiper-bl">
			 <swiper class="swiper" :options="maContentSwiperOption" >
			   <swiper-slide v-for="item in maContentSwiperItems" :key="item.id">
				   <div class="maContent_item" @click="onClickmaContentItem(item)">
					   <div class="maContent_item_img">
						   <img :src="item.cover" alt="">
					   </div>
					   <div class="maContent_item_title">{{item.title}}</div>
					   <div class="maContent_item_intro">{{item.speaker_name}}</div>
					   <div class="maContent_item_tag">
						   <div class="member_free" v-if="item.member_type == 1">会员免费</div>
						   <div class="member_vip" v-if="item.member_type == 2">会员专享</div>
					   </div>
				   </div>
			    </swiper-slide>
			  </swiper>
			  <div class="swiper-btn-wrap">
			    <div class="maContent swiper-btn-prev swiper-btn">
			      <i class="iconfont iconarrow_left"></i>
			    </div>
			    <div class="maContent swiper-btn-next swiper-btn">
			      <i class="iconfont iconarrow_right"></i>
			    </div>
			  </div>
			</div>
		</div>
		<buyvipDialog :payPopup="payPopup" v-show="payPopup" @close="close"></buyvipDialog>
		<buyvipResultDialog :payresPopup="payresPopup" v-show="payresPopup" :order_num="order_num" :order_status="order_status" :buy_type="buy_type" @closeres="closeres"></buyvipResultDialog>
	</div>
</template>

<script>
import { mapState } from 'vuex';
import requestApi from '@/service';
import Cookies from 'js-cookie';
import buyvipDialog from '@/components/buy_vipDialog.vue';
import buyvipResultDialog from '@/components/buy_vipResultDialog.vue';

// 记录swiper常量
const MAContent_SWIPER_PAGE_SIZE = 5; // 一页展示个数
export default {
	components: {
	  buyvipDialog,
	  buyvipResultDialog,
	},
	data() {
		return {
			user: {},
			equityContent:[
				{title: '解锁全部付费节目', intro: '会员有效期内，可观看全部万象课程、枝桠节目完整版在内的全部节目。'},
				{title: '支持1080P超清播放', intro: '观看视频享1080P超清画质，大屏或投屏观看更清晰。'},
				{title: '超低折扣购买特权', intro: '以超低折扣永久获取精品万象课，也可以用此价格买赠课程给好友。'},
				{title: '年费会员专属礼品', intro: '购买年费会员可获赠专属礼品，每笔年费订单对应一次礼品领取机会。'},
			],
			member_items: [],
			gift_infos:[],
			giftContentSwiperOption: {
			  slidesPerView:5,
			  slidesPerGroup: 5,
			  spaceBetween: 20,
			  navigation: {
			    prevEl: '.giftContent.swiper-btn-prev',
			    nextEl: '.giftContent.swiper-btn-next',
			  },
			},
			gift_infos_vip:[],
			vipgiftContentSwiperOption: {
			  slidesPerView:5,
			  slidesPerGroup: 5,
			  spaceBetween: 20,
			  navigation: {
			    prevEl: '.vipgiftContent.swiper-btn-prev',
			    nextEl: '.vipgiftContent.swiper-btn-next',
			  },
			},
			maContentSwiperOption: {
			  slidesPerView:5,
			  slidesPerGroup: 5,
			  spaceBetween: 20,
			  navigation: {
			    prevEl: '.maContent.swiper-btn-prev',
			    nextEl: '.maContent.swiper-btn-next',
			  },
			},
			maContentSwiperItems:[],//精彩内容数组
			payPopup: false,
			payresPopup: false,
			order_num:'',
			buy_type:'',
			order_status:1,//订单状态
		}
	},
	computed: {
	  ...mapState(['vipInfo','vipType']),
	},
	activated() {
		this.initUserInfo()
	},
	created() {
		this.checkLogin()
		this.get_vip_Content()
	},
	beforeRouteEnter(to, from, next) {
		if((from.path === '/' || !from.path) && to.query.order_num && to.query.buy_type){
			window.$router.replace({
				name: 'UserCentervip_detail',
				params: {
				  order_num: to.query.order_num,
				  buy_type: to.query.buy_type,
				},
			})
		}else {
			next(vm => {
				if (to.params.order_num && to.params.buy_type) {
				    vm.check_order(to.params.order_num,to.params.buy_type);
				}
				vm.initUserInfo()
			})
		}
	},
	methods:{
		//判断时候支付成功
		check_order(ordernum,buytype) {
			this.order_num = ordernum
			this.buy_type = buytype
			requestApi('/v3/api/h5/order/wanxiang/',
			{order_num:this.order_num,
			is_pc:1,
			buy_type:this.buy_type,},
			'GET').then(res => {
				if(res.msg == '等待支付') {
					
				}else {
					this.order_status = 2
					this.payresPopup = true
				}
			});
		},
		initUserInfo() {
		  this.user = this.$store.state.user || {};
		},
		buy_vip() {
			if (this.checkLogin()) {
			  this.payPopup = true;
			}
		},
		onClickmaContentItem(data) {
			// console.log(data)
			// return
			if(data.video_type == 17) {
				this.$router.push({
				  path: '/wanxiang/detail',
				  query: {
				    id: data.id,
				    episodeId: data.video_id,
				    isColumn: 1,
				  },
				});
			}
			if(data.video_type == 12) {
				this.$router.push({
				  path: '/zhiya/detail',
				  query: {
				    id: data.zhiya_id,
				    episodeId: data.id,
				  },
				});
			}
		},
		get_vip_Content() {
			requestApi('/v3/api/h5/member_join/').then(res => {
				this.gift_infos = res.gift_year_items
				this.gift_infos_vip = res.gift_year_items_vip
				this.maContentSwiperItems = res.member_program_items
				this.member_items = res.member_items
			})
		},
		close(val) {
			this.payPopup = false
		},
		closeres(val) {
			this.payresPopup = false
		},
	}
	
}
</script>

<style lang="scss" scoped>
	.vip_detail {
		width: 100%;
		box-sizing: border-box;
	}
	.user_info_card {
		box-sizing: border-box;
		position: relative;
		padding: 25px  40px;
		height: 120px;
		display: flex;
		justify-content: space-between;
		background: url("../../assets/imgs/ic_launcher_xhdpi.png");
		background-size: 100%;
		// background:linear-gradient(270.55deg, #FFE2DE 1.11%, #FFFFFF 93.48%);
		box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.25);
		border-radius: 4px 4px 0px 0px;
		overflow: hidden;
		.user_info_left {
			display: flex;
		}
		.user_avatar {
			width: 70px;
			overflow: hidden;
			border-radius: 50%;
		}
		.user_name_time {
			margin-left: 20px;
			color: #000000;
			position: relative;
			.user_name {
				font-weight: 900;
				font-size: 20px;
				line-height: 29px;
				width: 300px;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space:nowrap;
			}
			.user_time {
				position: absolute;
				bottom: 0;
				font-weight: 400;
				font-size: 15px;
				line-height: 22px;	
			}
		}
		.card_btn {
			display: flex;
			align-items: center;
			.vip_btn {
				width: 120px;
				height: 40px;
				text-align: center;
				background: #CE0900;
				line-height: 40px;
				font-weight: 900;
				font-size: 18px;
				color: #FFFFFF;
				cursor: pointer;
			}
		}
		
	}
	.vipEquity {
		background: #FFFFFF;
		box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.25);
		padding: 25px 40px 20px 40px;
		margin-top: 0px;
		.equity {
			display: flex;
			flex-wrap: wrap;
			justify-content: space-between;
			margin-top: 15px;
			.equity_item {
				background: #F5F5F5;
				border-radius: 3px;
				color: #000000;
				box-sizing: border-box;
				padding: 20px 15px;
				width: 340px;
				margin-bottom: 20px;
				.equity_item_title {
					font-weight: 500;
					font-size: 15px;
					line-height: 22px;
					margin-bottom: 10px;
				}
				.equity_item_intro {
					font-style: normal;
					font-weight: 400;
					font-size: 14px;
					line-height: 21px;		
				}
			}
		}
	}
	.vip_year_gift {
		background: #FFFFFF;
		box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.25);
		padding: 25px 40px;
		margin-top: 20px;
		.gift_tisp {
			font-style: normal;
			font-weight: 400;
			font-size: 15px;
			line-height: 22px;
			color: #808080;
			margin-top: 10px;
			margin-bottom: 15px;
		}
		.gift_content {
			display: flex;
		}
		.gift_item {
			width: 130px;
			margin-right: 25px;
			.gift_item_img {
				width: 100%;
				height: 130px;
				border-radius: 3px;
				overflow: hidden;
				img {
					width: 100%;
					height: 100%;
					object-fit: cover;
				}
			}
			.gift_item_title {
				margin-top: 5px;
				font-style: normal;
				font-weight: 500;
				font-size: 15px;
				line-height: 20px;	
				color: #000000;
				overflow: hidden;
				display: -webkit-box;
				-webkit-box-orient:vertical;
				-webkit-line-clamp:2;
			}
			.gift_item_price {
				font-style: normal;
				font-weight: 400;
				font-size: 14px;
				line-height: 21px;
				text-decoration-line: line-through;	
				color: #808080;
				
			}
		}
	}
	.vip_maContent {
		width: 100%;
		background: #FFFFFF;
		box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.25);
		padding: 25px 40px;
		margin-top: 20px;
		box-sizing: border-box;
		.maContent-swiper-bl {
			margin-top: 15px;
			position: relative;
			width: 100%;
		}
		.swiper {
			width: 100%;
			.swiper-slide {
				width: 128px !important;
			}
		}
		.maContent_item {
			position: relative;
			.maContent_item_img {
				border-radius: 4px;
				overflow: hidden;
				width: 100%;
				height: 170px;
				cursor: pointer;
				img {
					object-fit: cover;
					width: 100%;
					height: 100%;
				}
			}
			.maContent_item_title {
				margin-top: 8px;
				font-style: normal;
				font-weight: 500;
				font-size: 15px;
				line-height: 22px;
				color: #000000;
				overflow:hidden;
				text-overflow:ellipsis;
				display:-webkit-box;
				/*! autoprefixer: off */
				-webkit-box-orient: vertical;
				/* autoprefixer: on */
				-webkit-line-clamp:2; 
			}
			.maContent_item_intro {
				font-style: normal;
				font-weight: 400;
				font-size: 14px;
				line-height: 21px;
				color: #808080;
			}
			.maContent_item_tag {
				border-radius: 0px 4px; 
				overflow: hidden;
				position: absolute;
				top: 0;
				right: 0;
				color: #FFFFFF;
				font-size: 10px;
				font-weight: 700;
				.member_free {
					padding: 0 4px;
					background: linear-gradient(301.74deg, #8DA2D7 -2.53%, #7493BB 114.09%);
				}
				.member_vip {
					padding: 0 4px;
					background: linear-gradient(106.13deg, #DA3F34 3.9%, #DE6640 94.11%);
				}
				
			}
		}
	}	
	.gift_maContent {
		width: 100%;
		background: #FFFFFF;
		box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.25);
		padding: 25px 40px;
		margin-top: 20px;
		box-sizing: border-box;
		.giftContent-swiper-bl {
			margin-top: 15px;
			position: relative;
			width: 100%;
		}
		.swiper {
			width: 100%;
			.swiper-slide {
				width: 128px !important;
			}
		}
		.giftContent_item {
			position: relative;
			.maContent_item_img {
				border-radius: 4px;
				overflow: hidden;
				width: 100%;
				height: 170px;
				cursor: pointer;
				img {
					object-fit: cover;
					width: 100%;
					height: 100%;
				}
			}
			.maContent_item_title {
				margin-top: 8px;
				font-style: normal;
				font-weight: 500;
				font-size: 15px;
				line-height: 22px;
				color: #000000;
				overflow:hidden;
				text-overflow:ellipsis;
				display:-webkit-box;
				/*! autoprefixer: off */
				-webkit-box-orient: vertical;
				/* autoprefixer: on */
				-webkit-line-clamp:2; 
			}
			.maContent_item_intro {
				font-style: normal;
				font-weight: 400;
				font-size: 14px;
				line-height: 21px;
				color: #808080;
			}
		}
	}	
	.vipgift_maContent {
		width: 100%;
		background: #FFFFFF;
		box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.25);
		padding: 25px 40px;
		margin-top: 20px;
		box-sizing: border-box;
		.vipgiftContent-swiper-bl {
			margin-top: 15px;
			position: relative;
			width: 100%;
		}
		.swiper {
			width: 100%;
			.swiper-slide {
				width: 128px !important;
			}
		}
		.vipgiftContent_item {
			position: relative;
			.maContent_item_img {
				border-radius: 4px;
				overflow: hidden;
				width: 100%;
				height: 170px;
				cursor: pointer;
				img {
					object-fit: cover;
					width: 100%;
					height: 100%;
				}
			}
			.maContent_item_title {
				margin-top: 8px;
				font-style: normal;
				font-weight: 500;
				font-size: 15px;
				line-height: 22px;
				color: #000000;
				overflow:hidden;
				text-overflow:ellipsis;
				display:-webkit-box;
				/*! autoprefixer: off */
				-webkit-box-orient: vertical;
				/* autoprefixer: on */
				-webkit-line-clamp:2; 
			}
			.maContent_item_intro {
				font-style: normal;
				font-weight: 400;
				font-size: 14px;
				line-height: 21px;
				color: #808080;
			}
		}
	}
	.vip_title {
		display: flex;
		align-items: center;
		.shu {
			width: 5px;
			height: 18px;
			background: #D1291A;
			margin-right: 10px;
		}
		.title_txt {
			font-weight: 900;
			font-size: 24px;
			line-height: 34px;
			color: #333333;
			font-family: 'HYXinRenWenSong65W';
		}
		
	}
	
	
	
</style>